import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import "../../css/custom-sidenav.css";

const defaultNavLinks = [
  { label: "Asset Library", path: "/home" },
  {
    label: "Asset Insight",
    path: "https://assets.int.thomsonreuters.com/",
    external: true,
  },
];

const assetNavLinks = [
  { label: "Summary", path: "/summary" },
  { label: "Architecture Details", path: "/architecture-details" },
  { label: "Technology Stacks", path: "/technology-stacks" },
  { label: "Cloud Permit", path: "/cloud-permit" },
];

const specialPages = [
  "/runtime",
  "/customruntime",
  "/technology-stacks/addtechstack",
  "/technology-stacks/addbackendtechstack",
  "/technology-stacks/adddevopstechstack",
];

const defaultPages = ["/home", "/asset-insight"];

const SideNavCustom = ({ className = "" }) => {
  const location = useLocation();
  const [currentAssetId, setCurrentAssetId] = useState(null);

  useEffect(() => {
    const pathMatch = location.pathname.match(
      /^\/([^/]+)\/(?:summary|architecture-details|technology-stacks|cloud-permit)/
    );
    if (pathMatch && pathMatch[1]) {
      setCurrentAssetId(pathMatch[1]);
    } else {
      setCurrentAssetId(null);
    }
  }, [location.pathname]);

  const isDefaultPage = defaultPages.includes(location.pathname);
  const isSpecialPage = specialPages.includes(location.pathname);

  if (isSpecialPage) return null;

  return (
    <nav className={`custom-sidenav${className ? ` ${className}` : ""}`}>
      {currentAssetId && !isDefaultPage
        ? assetNavLinks.map((link) => {
            const url = `/${currentAssetId}${link.path}`;
            const isActive = location.pathname.includes(link.path);
            return (
              <Link
                key={link.path}
                to={url}
                className={`nav-item${isActive ? " active" : ""}`}
              >
                {link.label}
              </Link>
            );
          })
        : defaultNavLinks.map((link) =>
            link.external ? (
              <a
                key={link.path}
                href={link.path}
                target="_blank"
                rel="noopener noreferrer"
                className="nav-item"
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-item${
                  location.pathname === link.path ? " active" : ""
                }`}
              >
                {link.label}
              </Link>
            )
          )}
    </nav>
  );
};

export default SideNavCustom;
